//import { LazyInitializer } from 'Utils/LazyInitializer';

var hasSectionDependencies = hasSection();
//import iFrameResize from 'iFrameResizer';
var iFrameResize = undefined;

async function getComponents() {
    /* Dynamic Imports: https://webpack.js.org/guides/code-splitting/#dynamic-imports
     * The reason we need default is that since webpack 4, when importing a CommonJS module, 
     * the import will no longer resolve to the value of module.exports, 
     * it will instead create an artificial namespace object for the CommonJS module.
     * For more information on the reason behind this, read webpack 4: import() and CommonJs.
     * https://medium.com/webpack/webpack-4-import-and-commonjs-d619d626b655
    */

    let moduleName = 'iFrameResizer';
    console.log('>>> hotelReviews_TrustYou.js >>> moduleName: ' + moduleName);
    //const iFrameResize = await import(moduleName); // throw error: Cannot find module 'moduleName'
    //const iFrameResize = await import('iFrameResizer');
    //const { iFrameResize } = await import('iFrameResizer');
    const { default: iFrameResize } = await import('iFrameResizer');
    console.log('>>> hotelReviews_TrustYou.js >>> loaded: ' + moduleName);
    return {
        iFrameResize
    }
}


AppLoader.ready(async function () {
    if (hasSectionDependencies) {
        //console.log('>>> hotelReviews_TrustYou.js >>> init: AppLoader.ready');
        if (typeof iFrameResize == "undefined") {
            //console.log('>>> hotelReviews_TrustYou.js >>> init: iFrameResizer == "undefined"');
            let components = await getComponents();
            //console.log('>>> hotelReviews_TrustYou.js >>> done: getComponents');
            iFrameResize = components.iFrameResize;
        }
        //console.log('>>> hotelReviews_TrustYou.js >>> done: AppLoader.ready');
        InitializeTrustYou();
    }
});

//AppLoader.ready(async function () {
//    if (hasSectionDependencies) {
//
//        let init_Section = async function () {
//            if (typeof iFrameResize == "undefined") {
//                iFrameResize = (await getComponents()).iFrameResize;
//            }
//            InitializeTrustYou();
//            return true;
//        }
//        
//        let sectionElement = SectionElement();
//        let lazyInitializer = new LazyInitializer(sectionElement, init_Section);
//        lazyInitializer.init().then((result) => {
//            //console.log('>>> lazyInitializer >> InitializePackageCalendar done', result);
//        });
//        //lazyInitializer.init();
//    }
//});


function SectionElement() {
    return document.querySelector('#hotelReviews_TrustYou');
}

function hasSection() {
    let result =  (SectionElement() != null);
    //console.log('>>> hotelReviews_TrustYou.js >>> hasSection: ' + result);
    return result;
}

function InitializeTrustYou() {

    //console.log('>>> hotelReviews_TrustYou.js >>> iFrameResize: ', iFrameResize);
    //console.log('>>> hotelReviews_TrustYou.js >>> global.iFrameResize: ', global.iFrameResize);

    if (typeof global.iFrameResize == "undefined" && typeof iFrameResize == "function") {
        global.iFrameResize = iFrameResize;
    }

    AppLoader.raf(function () {
        if (typeof iFrameResize == "function") {
            iFrameResize();
        } else if (typeof global.iFrameResize == "function") {
            global.iFrameResize();
        }
    });

}